
import { Vue, Component, Prop } from "vue-property-decorator";

import GET_SUBSCRIPTION_PLANS from "@/apollo/payment/GetSubscriptionPlans.gql";

import AuthCard from "@/components/auth/AuthCard.vue";
import AuthFormLink from "@/components/auth/AuthFormLink.vue";
import PricePlans from "@/components/payment/prices/PricePlans.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import UiButton from "@/components/button/ui-button.vue";
import ScrollableContainer from "@/components/common/ScrollableContainer.vue";

import getActiveManagersCountCondition from "@/helpers/queryConditions/getActiveManagersCountCondition";

import RouteNames from "@/entities/RouteNames";
import { SubscriptionPlan } from "@/entities/payment/SubscriptionPlan";
import { Company } from "@/generated/graphql";

interface SubscriptionsDetails {
  activeManagersCount: number,
  subscriptionPlans: SubscriptionPlan[],
}

@Component({
  components: {
    AuthFormLink,
    AuthCard,
    PricePlans,
    LoadingOverlay,
    UiButton,
    ScrollableContainer,
  },
  apollo: {
    subscriptionsDetails: {
      query: GET_SUBSCRIPTION_PLANS,
      variables() {
        return {
          activeManagersCountCondition: getActiveManagersCountCondition(this.company.id),
        };
      },
      update(data): SubscriptionsDetails {
        const { subscriptionPlans } = data;
        const activeManagersCount = data.activeManagersCount.aggregate.count;
        return { subscriptionPlans, activeManagersCount };
      },
    },
  },
})
export default class PricePlansAuthSection extends Vue {
  @Prop({ type: Object, required: true }) readonly company!: Company;

  subscriptionsDetails: SubscriptionsDetails | null = null;

  get title(): string {
    if (this.subscriptionPlansExist) {
      return "Choose your plan";
    }

    return "";
  }

  get activeManagersCount(): number {
    return this.subscriptionsDetails?.activeManagersCount || 0;
  }

  // get subscriptionPlans(): SubscriptionPlan[] {
  //   return this.subscriptionsDetails?.subscriptionPlans || [];
  // }

  get subscriptionPlans(): SubscriptionPlan[] {
    const allSubscriptionPlans = this.subscriptionsDetails?.subscriptionPlans ?? [];
    const specificSubscriptionPlans = allSubscriptionPlans.filter(plan => {
      return plan.inner_name === 'STARTER' || plan.inner_name === 'GROWTH' || plan.inner_name === 'PREMIUM';
    });

    return specificSubscriptionPlans;
  }

  get isSubscriptionExists(): boolean {
    return this.company.subscriptions.length > 0;
  }

  get isLoading(): boolean {
    return this.$apollo.queries.subscriptionsDetails.loading;
  }

  get subscriptionPlansExist(): boolean {
    return this.subscriptionPlans.length > 0;
  }

  signOut(): void {
    // this.$router.push({ path: "/company_database/contractors" });
     window.location.href = "/company_database/contractors";
  }

  openPaymentCardPage(subscriptionPlanId: string): void {
    this.$router.push({
      name: RouteNames.ADD_PAYMENT_CARD_AUTH_FORM,
      params: {
        subscriptionPlanId,
      },
    });
  }
}
